const divi = () => {
  const visualBuilderURLParam = {
    name: 'et_fb',
    value: '1',
  };

  const visualBuilderIframeClass = 'et-fb-app-frame';
  const diviModuleClass = 'et_pb_module';
  const diviModuleInnerClass = 'et_pb_module_inner';

  let inVisualBuilder;

  const isVisualBuilderPage = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(visualBuilderURLParam.name, visualBuilderURLParam.value);
  };

  const isVisualBuilderIframe = () => {
    const htmlElement = document.getElementsByTagName('html').item(0);
    return htmlElement !== null
      ? htmlElement.classList.contains(visualBuilderIframeClass)
      : false;
  };

  const isInsideModuleWrapper = (element) => {
    const elementParent = element.parentNode;
    if (elementParent !== null && elementParent.classList.contains(diviModuleInnerClass)) {
      const elementGrandparent = elementParent.parentNode;
      return elementGrandparent !== null && elementGrandparent.classList.contains(diviModuleClass);
    }
    return false;
  };

  const init = () => {
    inVisualBuilder = isVisualBuilderPage() || isVisualBuilderIframe();
  };

  init();

  return {
    inVisualBuilder: () => inVisualBuilder,
    isInsideModuleWrapper: (element) => isInsideModuleWrapper(element),
  };
};

export default divi();
